import React from 'react';
import { useCart } from '../../contexts/CartContext';
import './Cart.scss';

const Cart = () => {
  const {
    cartItems,
    isCartOpen,
    closeCart,
    removeFromCart,
    updateQuantity,
    getCartTotal
  } = useCart();

  const handleCheckout = async () => {
    if (cartItems.length === 0) return;

    try {
      const response = await fetch('/api/create-checkout-session', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: cartItems }),
      });

      const data = await response.json();

      if (!response.ok) {
        console.error('Checkout error:', data.error);
        alert(data.error || 'Error creating checkout session. Please try again.');
        return;
      }

      window.location.href = data.url;
    } catch (error) {
      console.error('Error:', error);
      alert('Error processing checkout. Please try again.');
    }
  };

  if (!isCartOpen) return null;

  return (
    <div className="cart-overlay" onClick={closeCart}>
      <div className="cart-drawer" onClick={(e) => e.stopPropagation()}>
        <div className="cart-header">
          <h2>Your Cart</h2>
          <button className="close-cart" onClick={closeCart}>×</button>
        </div>

        {cartItems.length === 0 ? (
          <div className="cart-empty">
            <p>Your cart is empty</p>
          </div>
        ) : (
          <>
            <div className="cart-items">
              {cartItems.map((item) => (
                <div key={item.variantId} className="cart-item">
                  {item.image && (
                    <img src={item.image} alt={item.title} className="cart-item-image" />
                  )}
                  <div className="cart-item-details">
                    <h3>{item.title}</h3>
                    {item.variantTitle && item.variantTitle !== 'Default Title' && (
                      <p className="variant">{item.variantTitle}</p>
                    )}
                    <p className="price">${item.price.toFixed(2)}</p>
                    <div className="quantity-controls">
                      <button
                        onClick={() => updateQuantity(item.variantId, item.quantity - 1)}
                        disabled={item.quantity <= 1}
                      >
                        -
                      </button>
                      <span>{item.quantity}</span>
                      <button
                        onClick={() => updateQuantity(item.variantId, item.quantity + 1)}
                        disabled={Boolean(item.maxQuantity && item.quantity >= item.maxQuantity)}
                      >
                        +
                      </button>
                    </div>
                  </div>
                  <button
                    className="remove-item"
                    onClick={() => removeFromCart(item.variantId)}
                  >
                    ×
                  </button>
                </div>
              ))}
            </div>

            <div className="cart-footer">
              <div className="cart-total">
                <span>Total:</span>
                <span>${getCartTotal().toFixed(2)}</span>
              </div>
              <button className="checkout-button" onClick={handleCheckout}>
                Checkout with Stripe
              </button>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default Cart;
